import $ from '@modules/jquery-import';

/**
 * Flash HTMLelementNode backgroundColor from provided color back to original color
 * @param {string} color as hex, rgb, rgba or CSS constant
 * @param {,number} speed of animation effect
 * @param {,function} callback once animation is complete
 * @returns {undefined}
 */
$.fn.highlight = function ( color, speed, fn ) {

    if ( arguments.length < 1 ) {
        throw new Error( 'Wrong number of arguments for $.highlight: @color required.' );
    }

    var _this = this,
        elm = $( this ),
        args = arguments,
        s = (typeof speed === 'number') ? speed : 1600,
        func = (typeof args[args.length - 1] === 'function') ? args[args.length - 1] : null,
        org_color = elm.css( 'background-color' );

    elm.css( {backgroundColor: color} )
        .animate( {backgroundColor: org_color}, s, function () {
            if ( func && func.apply ) {
                func.apply( this, args );
            }
        } );
};
